import React from "react";
import Header from "../../Header";

export default function FeedContainer() {
    return(
        <>
        <Header/>
        </>
    )
}